<template>
  <div
    class="bg-white"
    :style="{ minHeight: `${height}px` }"
  >
    <div
      v-if="isLoading"
      class="flex items-center justify-center h-[80vh] bg-white"
    >
      <div class="text-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F95031] mx-auto mb-2" />
        <p class="text-gray-500">
          Memuat Manajemen Toko...
        </p>
      </div>
    </div>
    <iframe
      v-show="!isLoading"
      ref="v2iframe"
      frameborder="0"
      :height="height"
      width="100%"
      :src="iframeSrc"
      allow="clipboard-read; clipboard-write"
      @load="handleLoad"
    />
    <ManajemenTokoDialogs />
  </div>
</template>

<script>
import ManajemenTokoDialogs from './ManajemenTokoDialogs.vue'

export default {
  name: 'EmbedManajemenToko',
  components: {
    ManajemenTokoDialogs,
  },
  data() {
    return {
      height: 900,
      isLoading: true,
      // Uses the same environment variable often used for v2 React app
      iframeSrc: `${process.env.VUE_APP_BASE_AUTH_MODULE}/komstore/manajemen-toko`,
    }
  },
  methods: {
    handleLoad() {
      this.isLoading = false
    },
  },
}
</script>

<style scoped>
/* Optional styling if needed */
</style>
